<template>
  <div />
</template>

<script>
import { db } from "@/firebase";

export default {
  name: "GetSurvey",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    codeInput: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      survey: null,
      codeResponse: {},
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.params.surveyCode) {
          this.$bind(
            "codeResponse",
            db.collection("surveys").where("code", "==", this.$route.params.surveyCode).limit(1),
          );
        }
        if (this.$route.params.surveyId) {
          this.$bind("survey", db.collection("surveys").doc(this.$route.params.surveyId));
        }
      },
    },
    codeInput() {
      if (this.codeInput.length == 4) {
        this.$bind("codeResponse", db.collection("surveys").where("code", "==", this.codeInput).limit(1));
      } else {
        this.codeResponse = {};
      }
    },
    codeResponse() {
      this.survey = this.codeResponse[0];
    },
    survey() {
      this.$emit("input", this.survey);
    },
  },
};
</script>

<style></style>
